import { Box, TextField } from "@mui/material";
import { DataGrid } from "../helpers/DataGrid";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../../common/components/styled/styled";

type Props = {
  columns: any[];
  rows: any[];
  onSave: (rows: any[]) => void;
  onUndo: () => void;
  onClose: () => void;
  selectedDate: string;
};

export const CreateSalesAccountsConfig = ({
  columns,
  rows,
  onSave,
  onUndo,
  onClose,
  selectedDate,
}: Props) => {
  const { t } = useTranslation("settings");

  const salesAccountNewRow = {
    code: "",
    description: "",
    defaultVatPercent: 0,
    defaultVatCode: "",
    canUseInContract: true,
    canUseInExternalSales: false,
    canUseInGroupInternalSales: true,
  };

  return (
    <>
      <h2>{t("addNewExpenseType")}</h2>
      <Box display="flex" flexDirection="column" width="200px">
        <RoundedButton
          variant="outlined"
          sx={{ marginBottom: 3 }}
          onClick={onClose}
        >
          {t("common:cancel")}
        </RoundedButton>
        <TextField value={selectedDate} label={t("effectiveFrom")} disabled />
      </Box>
      <DataGrid
        columns={columns}
        rows={rows}
        onSave={onSave}
        onUndo={onUndo}
        newRow={salesAccountNewRow}
        hideSave={false}
        actions={["delete"]}
      />
    </>
  );
};
